import React from "react";
import { TextField } from '@rmwc/textfield';
import {
  DialogTitle,
  DialogContent
} from '@rmwc/dialog';

import '@material/dialog/dist/mdc.dialog.css';
import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';

class AthleteSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      distanceparameters: props.distanceparameters,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    if (event.target.id === "tipToHandA") {
      this.setState({
        distanceparameters: {
          ...this.state.distanceparameters,
          tipToHandA: event.target.valueAsNumber,
        },
      }, () => {
        this.props.onChange(this.state.distanceparameters);
      });
    } else if (event.target.id === "tipToHandB") {
      this.setState({
        distanceparameters: {
          ...this.state.distanceparameters,
          tipToHandB: event.target.valueAsNumber,
        },
      }, () => {
        this.props.onChange(this.state.distanceparameters);
      });
    }
  }
  render() {
    return (
      <div>
        <DialogTitle>Blade tip to hand distances (mm)</DialogTitle>
        <DialogContent style={{paddingTop: '15px'}}>
          <TextField
            id="tipToHandB"
            type="number"
            outlined
            style={{width: '100%'}}
            label={this.props.labelB}
            value={this.state.distanceparameters.tipToHandB}
            onChange={(event) => this.handleChange(event)}/>
          <br/>
          <br/>
          <TextField
            id="tipToHandA"
            type="number"
            outlined
            style={{width: '100%'}}
            label={this.props.labelA}
            value={this.state.distanceparameters.tipToHandA}
            onChange={(event) => this.handleChange(event)}/>
        </DialogContent>
      </div>
    );
  };
};

export default AthleteSettings;